import useListAllDestinationsForEnv from "@/destinations/v2/hooks/useListAllDestinationsForEnv";

export default function useDestinationById(id: string) {
  const { data, isLoading, isError } = useListAllDestinationsForEnv();

  if (isLoading || isError) {
    return undefined;
  }

  return data?.destinations.find((dest) => dest.id === id);
}
